import { LogStatusT } from "../../../../domain/entities";
import React from "react";
import {
  Select,
  SelectProps,
} from "../../../../../../shared/infrastructure/ui/components/libs/select";

export const LogStatusSelect = ({
  onChange,
  ...props
}: Omit<
  SelectProps<LogStatusT>,
  | "getOptionLabel"
  | "options"
  | "labelProp"
  | "renderOptionComponent"
  | "asyncFilter"
>): React.ReactElement => {
  const getItemLabel = (option: LogStatusT): string => option.description;

  return (
    <Select<LogStatusT>
      onChange={onChange}
      label={getItemLabel}
      labelProp="id"
      renderOptionComponent={(option) => option.description}
      {...props}
      options={[
        { id: "approved", description: "Approved" },
        { id: "rejected", description: "Rejected" },
        { id: "counter", description: "Counter" },
        { id: "expired", description: "Expired" },
      ]}
    />
  );
};
